module.exports = __webpack_public_path__ + "img/gallery-4.487547e3.png";